module.exports = __webpack_public_path__ + "static/media/kids_babies.33791242.jpg";